/**
 * The run uuids a headset test message names; empty when it names none.
 * Headsets put it on the message itself; the snapshot copy is checked too so
 * a message that only carries it there is still recognised.
 */
export function testRunUuidsOf(message: unknown): string[] {
  if (!message || typeof message !== "object") return [];
  const uuids: string[] = [];
  const own = (message as Record<string, unknown>)["uuid"];
  if (typeof own === "string" && own) uuids.push(own);
  const snapshot = (message as Record<string, unknown>)["snapshot"];
  if (snapshot && typeof snapshot === "object") {
    const nested = (snapshot as Record<string, unknown>)["uuid"];
    if (typeof nested === "string" && nested) uuids.push(nested);
  }
  return uuids;
}

/**
 * The uuid of another test run when `message` belongs to one, else null.
 * A message without a uuid (older headsets) or a page without a test id
 * cannot be judged and counts as the current run's.
 * The second eye of a back-to-back test runs as `<uuid>2` on both sides, so
 * once the page moves to it, late messages of the first eye are foreign too.
 */
export function foreignTestRunUuid(message: unknown, currentTestId: string | null): string | null {
  if (!currentTestId) return null;
  return testRunUuidsOf(message).find((uuid) => uuid !== currentTestId) ?? null;
}
